// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy{color:#a2b4b4;opacity:.4;cursor:pointer;font-size:14px}.copy:hover{opacity:.9;color:#fff}.copy:hover span:first-of-type{text-decoration:underline}.copy .UI-checked{color:#14c6ab;margin-left:7px;line-height:16px}", ""]);
// Exports
module.exports = exports;
